import { useState } from 'react'

export { TabHeadings } from './tab-headings'

interface Props<TTabs extends string> {
  readonly defaultTabID: TTabs
  readonly children: (props: {
    readonly previousTabID: TTabs | undefined
    readonly currentTabID: TTabs
    readonly setCurrentTabID: (tabID: TTabs) => void
  }) => any
}

/**
 * Component for tracking the current and previous tabs.
 */
export function ActiveTabManager<TTabs extends string>({
  defaultTabID,
  children
}: Props<TTabs>) {
  const [history, setHistory] = useState<TTabs[]>([defaultTabID])
  return children({
    previousTabID: history.length > 1 ? history[1] : undefined,
    currentTabID: history[0],
    setCurrentTabID: (tabID) => setHistory([tabID, history[0]])
  })
}
